export default function Button({
  className,
  onClick,
  disabled,
  type,
  text,
  icon,
  submitting
}) {
  return (
    <button
      className={className}
      onClick={onClick}
      disabled={disabled || submitting}
      type={type}>
      {icon && icon}
      <p className="btn-text">{submitting && <span className="spinner-border spinner-border-sm mr-1"/>}{text}</p>
    </button>
  );
}
